import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const KEY = "hr_consent";

export function ConsentBanner() {
  const [choice, setChoice] = useState("pending");

  useEffect(() => {
    try {
      const v = localStorage.getItem(KEY);
      if (v === "accepted" || v === "rejected") setChoice(v);
    } catch (e) { /* ignore */ }
  }, []);

  const decide = (value) => {
    try { localStorage.setItem(KEY, value); } catch (e) { /* ignore */ }
    if (value === "accepted" && window.__hrEnableAnalytics) window.__hrEnableAnalytics();
    if (value === "rejected" && window.__hrDisableAnalytics) window.__hrDisableAnalytics();
    setChoice(value);
  };

  if (choice !== "pending") return null;

  return (
    <div data-testid="consent-banner"
      className="fixed inset-x-0 bottom-0 z-[120] px-4 pb-4 sm:px-6 sm:pb-6">
      <div className="mx-auto max-w-3xl rounded-2xl border border-olive/15 bg-cream shadow-[0_20px_60px_-20px_rgba(86,94,66,0.5)] p-5 sm:p-6">
        <h2 className="font-serif text-lg text-olive-deep">Vi respekterer personvernet ditt</h2>
        <p className="mt-2 text-[14px] text-olive/75 leading-relaxed">
          Vi bruker kun nødvendige informasjonskapsler for at siden skal fungere. Valgfri
          statistikk (analyse) settes bare hvis du sier ja. Les mer i{" "}
          <Link to="/personvern" className="underline text-terra hover:text-olive-deep">personvernerklæringen</Link>.
        </p>
        <div className="mt-4 flex flex-col sm:flex-row gap-3">
          <button onClick={() => decide("accepted")} data-testid="consent-accept"
            className="flex-1 rounded-md bg-terra px-5 py-3 text-cream text-[12px] font-semibold uppercase tracking-[0.1em] hover:bg-olive-deep transition-colors">
            Godta alle
          </button>
          <button onClick={() => decide("rejected")} data-testid="consent-reject"
            className="flex-1 rounded-md border border-olive/40 px-5 py-3 text-olive-deep text-[12px] font-semibold uppercase tracking-[0.1em] hover:bg-olive-deep hover:text-cream transition-colors">
            Kun nødvendige
          </button>
        </div>
      </div>
    </div>
  );
}
